import type { PredictionContractListResponse } from '@/types/prediction.types';

/** Conditional status is inferred from linkage conids; the API does not return a boolean flag. */
export function isConditionalProduct(response: PredictionContractListResponse | undefined): boolean {
  if (!response) return false;
  if (response.condition_conid || response.settlement_conid) return true;
  return (
    response.complex_contracts?.some(({ condition_conid, settlement_conid }) =>
      Boolean(condition_conid || settlement_conid),
    ) ?? false
  );
}
